import React from 'react'
import { Typography } from 'antd'
import {
  BestLayoutProposalFragment,
  BestLayoutSelfServeSpatialConfigurationFragment,
} from './BestLayout.generated-types'

const { Text } = Typography

type LayoutConfiguration = Omit<BestLayoutSelfServeSpatialConfigurationFragment, '__typename'>

const DEFAULT_LAYOUT = 'boardroom'

export const BestLayout: React.FC<{
  attendees: number
  chosenLayout: string
  proposal: BestLayoutProposalFragment
}> = ({
  attendees,
  chosenLayout,
  proposal: {
    space: { spatialConfigurations: layouts },
  },
}) => {
  const findPreferredLayout = (layout: LayoutConfiguration): boolean => {
    return layout.name.toLowerCase() === chosenLayout.toLocaleLowerCase()
  }

  const findDefaultLayout = (layout: LayoutConfiguration): boolean => {
    return layout.name.toLowerCase() === DEFAULT_LAYOUT
  }

  const findClosestLayout = (best: number, curr: LayoutConfiguration, idx): number => {
    if (Math.abs(layouts[best].capacity - attendees) <= Math.abs(curr.capacity - attendees)) {
      return best
    } else {
      return idx
    }
  }

  const preferred: LayoutConfiguration = layouts.find(findPreferredLayout) // we're always to search for at least this one, so can do this here
  const match: LayoutConfiguration =
    preferred ||
    (layouts.find(findDefaultLayout)
      ? layouts.find(findDefaultLayout)
      : layouts[layouts.reduce(findClosestLayout, 0)])

  return (
    <Text
      style={{
        fontWeight: 600,
        fontSize: '16px',
        color: '#262626',
        textTransform: 'capitalize',
      }}>{`${match.name}: ${match.capacity}`}</Text>
  )
}
